import { IStoreType } from "@/interfaces/IStoreType";
import { GettersType } from "@/store/getters/type";
import { IOperator } from "@/interfaces/IOperator";

 export default {
    [GettersType.GET_OPERATOR]: (state: IStoreType): IOperator | null => state.operator,
 }